import { pgTable, uuid, integer, text, timestamp, index } from "drizzle-orm/pg-core";
import { products } from "./products.js";
import { inventoryLocations } from "./inventory-locations.js";

export const inventoryMovements = pgTable(
  "inventory_movements",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    productId: uuid("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    fromLocationId: uuid("from_location_id").references(() => inventoryLocations.id),
    toLocationId: uuid("to_location_id").references(() => inventoryLocations.id),
    qty: integer("qty").notNull(),
    reason: text("reason")
      .notNull()
      .$type<"sale" | "transfer" | "stock_in" | "write_off" | "correction">(),
    orderId: uuid("order_id"),
    note: text("note"),
    createdBy: uuid("created_by"),
    createdByKind: text("created_by_kind").$type<"admin" | "customer" | "system">(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    productIdx: index("inventory_movements_product_id_idx").on(t.productId),
    createdAtIdx: index("inventory_movements_created_at_idx").on(t.createdAt),
  })
);

export type InventoryMovement = typeof inventoryMovements.$inferSelect;
export type NewInventoryMovement = typeof inventoryMovements.$inferInsert;

export const INVENTORY_REASONS = [
  "sale",
  "transfer",
  "stock_in",
  "write_off",
  "correction",
] as const;
export type InventoryReason = (typeof INVENTORY_REASONS)[number];
